import React from "react";
import PropTypes from "prop-types";

export const AudioPreview = ({ selectedDocument }) => {
  const audioUrl = selectedDocument?.[0]?.uri?.replace(
    "data:application/pdf",
    "data:audio/mpeg"
  );
  const fileName = selectedDocument?.[0]?.fileName;
  return (
    <div>
      <div className="viewer-header">
        <div
          id="file-name"
          data-testid="file-name"
          className="viewer-file-name"
        >
          {fileName}
        </div>
      </div>
      {selectedDocument && selectedDocument.length > 0 ? (
        <div className="pt-3">
          <audio controls src={audioUrl}>
            <track
              kind="captions"
              label="No captions"
              style={{ display: "none" }}
            />
            Your browser does not support the audio element.
          </audio>
        </div>
      ) : (
        <div>
          <br />
          <h4>Choose before Pressing the Upload button</h4>
        </div>
      )}
    </div>
  );
};

AudioPreview.propTypes = {
  selectedDocument: PropTypes.arrayOf(
    PropTypes.shape({
      uri: PropTypes.string.isRequired,
      fileName: PropTypes.string.isRequired,
    })
  ).isRequired,
};
